import { render, staticRenderFns } from "./BrowseStrategiesPage.vue?vue&type=template&id=06c97e51&scoped=true"
import script from "./BrowseStrategiesPage.vue?vue&type=script&lang=js"
export * from "./BrowseStrategiesPage.vue?vue&type=script&lang=js"
import style0 from "./BrowseStrategiesPage.vue?vue&type=style&index=0&id=06c97e51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c97e51",
  null
  
)

export default component.exports